<div class="notif-bell">
  <button type="button" class="notif-bell__trigger" (click)="toggle()" aria-label="Уведомления">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span *ngIf="unreadCount > 0" class="notif-bell__badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
  </button>

  <div class="notif-bell__panel" *ngIf="open">
    <div class="notif-bell__panel-header">
      <button
        type="button"
        class="notif-bell__mark-all"
        *ngIf="groups.length > 0"
        (click)="markAllAsRead()"
      >{{ markAllReadText }}</button>
    </div>

    <div class="notif-bell__list">
      <div *ngIf="loading" class="notif-bell__state">…</div>
      <div *ngIf="loadError && !loading" class="notif-bell__state notif-bell__state--error">{{ loadError }}</div>
      <div *ngIf="!loading && !loadError && groups.length === 0" class="notif-bell__state">
        {{ emptyText }}
      </div>

      <button
        type="button"
        class="notif-bell__item"
        [class.notif-bell__item--unread]="group.unreadCount > 0"
        *ngFor="let group of groups"
        (click)="openNotification(group)"
      >
        <span class="notif-bell__item-icon" [ngSwitch]="iconFor(group)">
          <svg *ngSwitchCase="'chat'" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg *ngSwitchDefault width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="notif-bell__item-body">
          <span class="notif-bell__item-title-row">
            <span class="notif-bell__item-title">{{ displayTitle(group) }}</span>
            <span class="notif-bell__item-count" *ngIf="group.items.length > 1">{{ group.items.length }}</span>
          </span>
          <span class="notif-bell__item-time">{{ timeAgo(group.latest.createdAt) }}</span>
        </span>
        <span class="notif-bell__item-dot" *ngIf="group.unreadCount > 0"></span>
      </button>
    </div>
  </div>
</div>
